export enum TRANSACTION_MESSAGE_TYPE {
	PLAIN = 0,
	JSON = 1
}
